export const WL_SS_KEY = 'white-label-referral-code';
